<script>
  import {getContext } from "svelte";
  export let options;
  export let label;
  export let name;
  export let values;
  export let required = false;
  export let containerClass = "mt-1 sm:mt-0 sm:col-span-2"
  const { onFormChange } = getContext("form");
</script>

<label
  for={name}
  class="justify-self-end block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
>
  {label}
  {#if required}
    <span class="text-red-500">*</span>
  {/if}
</label>
<div class={containerClass}>
  {#each options as option, i}
    <div class="mt-4 space-y-4">
      <div class="flex items-center">
        <input
          {name}
          id={`${name}-${i}`}
          type="checkbox"
          class="focus:ring-yellow-500 h-4 w-4 text-yellow-600 border-gray-300"
          value={option.value}
          on:change={onFormChange}
          checked={values?.includes(option.value)}
        />
        <label
          for={`${name}-${i}`}
          class="ml-3 block text-sm font-medium text-gray-700"
        >
          {option.label}
        </label>
      </div>
    </div>
  {/each}
</div>
